<div matRipple class="container" fxLayout="column" [nbSpinner]="isLoading" appDragDrop (click)="fileInput.click()"
    (fileDropped)="onFileSelected($event['0'])">
    <div class="center" *ngIf="!picture" [ngClass]="shape">
        <mat-icon>cloud_upload</mat-icon>
        <p>Drop your file here or</p>
        <p class="blue">Click to Upload</p>
    </div>
    <input type="file" #fileInput [accept]="accept" (change)="onFileSelected($event.target.files['0'])"
        style="display:none;" />
    <div *ngIf="picture" class="img-wrapper center" [ngClass]="shape">
        <img class="picture" [src]="picture">
    </div>
    <p class="message" *ngIf="message && !file">{{message}}</p>
    <div *ngIf="file" class="file-info" fxLayout="row">
        <p class="message">{{file.name}}</p>
        <mat-icon (click)="onCancel($event)">
            close
        </mat-icon>
    </div>
</div>